const categories = [
    "Software",
    "Electronics",
    "Computer-Vision"
]
export default categories;


// WEBPACK FOOTER //
// ./src/data/Category.js